import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

// LOCAL STORAGE helpers
export function getLocalCart() {
  try {
    const raw = localStorage.getItem('local_cart');
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function setLocalCart(items) {
  localStorage.setItem('local_cart', JSON.stringify(items));
  window.dispatchEvent(new Event('cartUpdated'));
}

// Unified addToCart: always uses server cart if logged in
export async function addToCart(product, quantity = 1, navigate) {
  const token = localStorage.getItem('token');
  if (token) {
    // Update server cart
    await API.post(
      '/cart/add',
      { productId: product.productId || product.id, quantity },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    window.dispatchEvent(new Event('cartUpdated'));
    return;
  }
  // Not logged in: update local cart and optionally redirect to login
  if (navigate) {
    navigate('/login');
  } else {
    window.location.href = '/login';
  }
}

// For legacy code: still allow direct local cart manipulation for guests
export function addToLocalCart(product, quantity = 1) {
  const cart = getLocalCart();

  const productId = product.productId || product.id;
  if (!productId) throw new Error("Product missing ID");

  const idx = cart.findIndex(i => i.productId === productId);

  if (idx > -1) {
    cart[idx].quantity += quantity;
  } else {
    cart.push({
      productId,
      quantity,
      price: product.price || 0,   // ✅ always store price
      name: product.name,          // ✅ for easy display
      product,                     // full object
    });
  }

  setLocalCart(cart);
  return cart;
}



export function updateLocalCartQty(productId, qty) {
  const cart = getLocalCart();
  const idx = cart.findIndex(i => i.productId === productId);
  if (idx > -1) {
    cart[idx].quantity = qty;
    if (qty <= 0) cart.splice(idx, 1);
    setLocalCart(cart);
  }
  return cart;
}

export function removeLocalCartItem(productId) {
  const cart = getLocalCart().filter(i => i.productId !== productId);
  setLocalCart(cart);
  return cart;
}

export function clearLocalCart() {
  setLocalCart([]);
}

// SERVER API helpers (when user is logged in)
function authHeader() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function fetchServerCart() {
  const res = await API.get('/cart', { headers: authHeader() });
  // Always return an array
  return res.data.items || [];
}

export async function addOrUpdateServerItem(productId, quantity = 1) {
  const res = await API.post('/cart', { productId, quantity }, { headers: authHeader() });
  return res.data;
}

export async function updateServerItem(id, quantity) {
  const res = await API.put(`/cart/${id}`, { quantity }, { headers: authHeader() });
  return res.data;
}

export async function removeServerItem(id) {
  const res = await API.delete(`/cart/${id}`, { headers: authHeader() });
  return res.data;
}

export async function clearServerCart() {
  const res = await API.delete('/cart/clear',{ data: {} },{ headers: authHeader() });
  return res.data;
}

// Merge guest cart to server cart after login
export async function mergeLocalToServer() {
  const items = getLocalCart().map(i => ({ productId: i.productId, quantity: i.quantity }));
  if (items.length === 0) return null;
  const res = await API.post('/cart/merge', { items }, { headers: authHeader() });
  clearLocalCart();
  return res.data;
}
